export default "__VITE_ASSET__d0283fe8__"